export function getLocalizedLanguageName(code: string): string {
  try {
    const displayNames = new Intl.DisplayNames([navigator.language], {
      type: "language",
    });
    return displayNames.of(code) ?? "English";
  } catch {
    return "English";
  }
}

export function isBrowserJapanese(): boolean {
  if (typeof navigator === "undefined") return false;
  const lang = navigator.language?.toLowerCase();
  return lang?.startsWith("ja");
}
